
import Vue from 'vue';
import { newClient } from './axios-client-new';
import { newClient as newClientOld } from './axios-client-old';
import { get } from '@/util';
import { Dialog } from 'vant';
import { getAppName } from "../util";
let appName = getAppName();
 export const startTime =  'startTheTime'
// 获取当前地区
export const getCountryListAjax = function (language) {
  return newClientOld().post('/web/h5/getCountryList?language=' + language)
}


// 获取当前地区
export const getPayChannelsAjax = function (params) {
  return newClientOld().get('/web/h5/getPayChannels', { params: params })
}
/**
 * 获取充值结果及显示信息
 * 接口（参考文档）：GET /api/token/trade/pay/limit/info
 * params: 对应接口的 query 参数（例如 tradeNo, orderNo 等）
 */
/**
 * 获取充值限制信息（根据接口文档）
 * 接口：GET /api/token/trade/pay/limit/info
 * Query params: s (string) - 必填
 */
export const getPayLimitInfo = function () {
  // 接口期望 query 参数名为 s，构建 params 对象并调用
  const params = { s: Vue.prototype.$globalData.source ? Vue.prototype.$globalData.source : 'h5' };
  return newClient().get('/api/h5/token/trade/pay/limit/info', { params: params });
}
/**
 * 点击了卡片中的币商
 * 接口：POST /api/token/trade/pay/limit/click
 * body: { no?: string }
 */
export const clickCardMerchant = function () {
  return newClient().post('/api/h5/token/trade/pay/limit/click', { no: localStorage.getItem('no') });
}
/**
 * 提交用户反馈
 * 接口文档：POST /api/h5/foundation/assistant/syshelp/submitFeedBack
 * payload 示例见接口文档（typeId, reportId, email, platform, device, detail, fileList 等）
 */
export const submitUserFeedback = async function (payload = {}) {
  // 直接以 JSON body 提交，Content-Type 由 axios 客户端处理
  return await newClient().post('/api/h5/token/foundation/assistant/syshelp/submitFeedBack', payload);
}
/**
 * 跳转到反馈页面（来自支付页面）
 * 将在路由中加入 query 参数 from=pay
 * @param {string} orderNo - 订单号
 * @param {string} email - 用户邮箱
 */
export const gotoFeedbackFromPay = function (orderNo, email) {
  const query = { from: 'pay' };
  if (orderNo) {
    query.orderNo = orderNo;
  }
  if (email) {
    query.email = email;
  }
  if (window && window.rootApp && window.rootApp.$router) {
    window.rootApp.$router.push({ path: '/feedback', query });
  } else {
    // 备用：直接改变 location（不推荐）
    const queryStr = new URLSearchParams(query).toString();
    window.location.href = `/#/feedback?${queryStr}`;
  }
}
// 创建订单
export const createOrderAjax = async function (params, payPlatformId, payPage = 0) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source,
    "payPage": payPage
  }
  // console.log(newJson);
  let api = '';
  if (payPlatformId === 10076) {
    api = process.env.paypal_created_api_10076;
  }

  const payResult = await newClientOld().post(api + '/web/h5/pay/createOrder?param=' + encodeURIComponent(JSON.stringify(newJson)));
  // await  handleFirstPayAfter(payResult);
  console.log('createOrderAjax result:', payResult);
  await handleCreateOrderResult(payResult, payPage);
  return payResult;


}

// pagSmile支付方式

export const pagSmileCreateOrderAjax = async function (params, payPage = 0) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source,
    "payPage": payPage
  }
  // console.log(newJson);
  const payResult = await newClient().post('/api/h5/token/trade/pagSmile/payIn/sendPay?param=' + encodeURIComponent(JSON.stringify(newJson)));
  // await  handleFirstPayAfter(payResult);
  console.log('pagSmileCreateOrderAjax result:', payResult);
  await handleCreateOrderResult(payResult, payPage);
  return payResult;
}

// payssion支付方式
export const payssionCreateOrderAjax = async function (params, payPage = 0) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source,
    "payPage": payPage
  }
  const payResult = await newClient().post('/api/h5/token/trade/payssion/payIn/sendPay', newJson);
  // await  handleFirstPayAfter(payResult);
  console.log('payssionCreateOrderAjax result:', payResult);
  await handleCreateOrderResult(payResult, payPage);
  return payResult;
}

// dlocal 支付方式
export const dlocalCreateOrderAjax = async function (params, payPage = 0) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source,
    "payPage": payPage
  }
  // console.log(newJson);
  const payResult = await newClient().post('/api/h5/token/trade/dlocal/payIn/sendPay?param=' + encodeURIComponent(JSON.stringify(newJson)));
  // await  handleFirstPayAfter(payResult);
  console.log('dlocalCreateOrderAjax result:', payResult);
  await handleCreateOrderResult(payResult, payPage);
  return payResult;

}


// 订单处理后首充
/*
async function handleFirstPayAfter(payResult){

  // 风险值过高
  let message;
  if(get(payResult, 'data.data.payUrl')  == -1 || get(payResult, 'result.payUrl') == -1) {
    message = window.rootApp.$t('m.pay_fail_system_risk')  + window.rootApp.$t('m.support_contant_whatsapp', { msg: appName });
  }

  if(get(payResult, 'data.data.payUrl')  == -2 || get(payResult, 'result.payUrl') == -2) {
    message = window.rootApp.$t('m.paystyle_unavailabel_change_other') + window.rootApp.$t('m.support_contant_whatsapp', { msg: appName });
  }

  if(message){
    Dialog.alert({
      message: message,
      confirmButtonText: 'OK'
    });
    return Promise.reject('error payIndex')
  }
}
*/


// dukPay 支付方式
export const dukPayCreateOrderAjax = async function (params, payPage = 0) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source,
    "payPage": payPage
  }
  // console.log(newJson);
  const payResult = await newClient().post('/api/h5/token/trade/dukPay/payIn/sendPay?param=' + encodeURIComponent(JSON.stringify(newJson)));
  // await  handleFirstPayAfter(payResult);
  console.log('dukPayCreateOrderAjax result:', payResult);
  await handleCreateOrderResult(payResult, payPage);
  return payResult;
}
// CodaPay 支付方式
export const codaPayCreateOrderAjax = async function (params, payPage = 0) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source,
    "payPage": payPage
  }
  // console.log(newJson);
  const payResult = await newClient().post('/api/h5/token/trade/coda/payIn/sendPay?param=' + encodeURIComponent(JSON.stringify(newJson)));
  // await  handleFirstPayAfter(payResult);
  console.log('codaPayCreateOrderAjax result:', payResult);
  await handleCreateOrderResult(payResult, payPage);
  return payResult;
}

/**
 * peymentWall-paypal充值方式
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const paymentWallPaypalCreateOrder = async function (params, payPage = 0) {
  const newJson = {
    ...params,
    "source": Vue.prototype.$globalData.source,
    "payPage": payPage
  }
  // console.log(newJson);
  const payResult = await newClient().post('/api/h5/token/trade/paymentWallPayPal/payIn/sendPay', newJson);
  // await  handleFirstPayAfter(payResult);
  console.log('paymentWallPaypalCreateOrder result:', payResult);
  await handleCreateOrderResult(payResult, payPage);
  return payResult;
}


// 下单对下单结果进行处理
async function handleCreateOrderResult(payResult, payPage = 0) {
  console.log('payResult handleCreateOrderResult', payResult);
  // 初始化 data.fail，供调用方通过 res.data.fail 判断是否需要阻止后续操作

   const data = payResult.data.data || payResult.data.result  ;

  if (payResult && data && payResult.data.code === 1) {
    // 显示卡片时，将订单号存储起来。
    localStorage.setItem('no', data.no)
    // data.showCard = true;
    // data.showTrader = true;
    // 显示卡片
    if (data.showCard) {
      // 调起反馈充值弹窗列表，直接展开
      window.rootApp.$store.dispatch('rechargeIntercept/openExpanded', data);
      // 标记失败，阻止后续操作
      try {
        payResult.fail = true;
        if (payResult.data) payResult.data.fail = true;
      } catch (e) {}
      return;
    }

    // 显示弹窗
    if (data.showDialog) {
      Dialog.confirm({
        message: window.rootApp.$t('m.recharge_fail_risk_network'),
        confirmButtonText: window.rootApp.$t('m.feedback'),
        cancelButtonText: window.rootApp.$t('m.falseText')
      }).then(() => {
        // 跳转到反馈页面
        gotoFeedbackFromPay(data.no, data.email);
      }).catch(() => {
        // 取消按钮点击，关闭弹窗
      });

      try {
        payResult.fail = true;
        if (payResult.data) payResult.data.fail = true;
      } catch (e) {}
      return;
    }

    // 显示默认提示弹窗

    if (data.showDefault) {
      Dialog.confirm({
        message: window.rootApp.$t('m.connection_fail_retry_feedback'),
        confirmButtonText: window.rootApp.$t('m.feedback'),
        cancelButtonText: window.rootApp.$t('m.falseText')
      }).then(() => {
        // 跳转到反馈页面
        gotoFeedbackFromPay(data.no, data.email);
      }).catch(() => {
        // 取消按钮点击，关闭弹窗
      });
      try {
        payResult.fail = true;
        if (payResult.data) payResult.data.fail = true;
      } catch (e) {}
      return;
    }



    //  需要定时器轮询充值结果
   localStorage.setItem(startTime, data.no )

  }

   
  
}









// WEBPACK FOOTER //
// ./src/api/pay.js